import request from '../utils/service'

import router from '../route/router.js'
const api = {
  getParkingDetail: function(data) {
    return request({
      url: '/api/v1/getParkDetail',
      method: 'post',
      data: data
    })
  },
  getBookableParksByName: function(data) {
    return request({
      url: '/api/v1/getBookableParksByName',
      method: 'post',
      data: Object.assign({
        thirdId: localStorage.getItem('openId'),
        lastId: 0,
        pageSize: 9999
      }, data)
    })
  },
  createBookOrder: function(data) {
    return request({
      url: '/api/v1/createBookOrder',
      method: 'post',
      data: Object.assign({
        thirdId: localStorage.getItem('openId')
      }, data)
    })
  },
  getBookPackageInfo: function(data) {
    return request({
      url: '/api/v1/getBookPackageInfo',
      method: 'post',
      data: data
    })
  },
  getRecommendBerthInfo: function(data) {
    return request({
      url: '/api/v1/getRecommendBerthInfo',
      method: 'post',
      data: data
    })
  },
  getAllPlateInfo: function() {
    const promise = new Promise((resolve) => {
      request({
        url: '/api/v1/getAllPlateInfo',
        method: 'post',
        data: {
          thirdId: localStorage.getItem('openId')
        }
      }).then(data => {
        if (data.list == null) {
          // console.log(router);
          router.push('/addCar')
        }
        resolve(data)
      })
    })
    return promise
  },
  getBerthInfo: function(data) {
    return request({
      url: '/api/v1/getBerthInfo',
      method: 'post',
      data: data
    })
  },
  getParkingBerthType: function(data) {
    return request({
      url: '/api/v1/getParkingBerthType',
      method: 'post',
      data: data
    })
  },
  getRecommendParkingList: function() {
    return request({
      url: '/api/v1/getRecommendParkingList',
      method: 'post',
      data: {
        thirdId: localStorage.getItem('openId')
      }
    })
  },
  getBookOrderList: function(data) {
    return request({
      url: '/api/v1/getBookOrderList',
      method: 'post',
      data: Object.assign({
        thirdId: localStorage.getItem('openId'),
        lastId: 0,
        pageSize: 15
      }, data)
    })
  },
  getBookOrderDetailInfo: function(data) {
    return request({
      url: '/api/v1/getBookOrderDetailInfo',
      method: 'post',
      data: Object.assign({
        thirdId: localStorage.getItem('openId')
      }, data)
    })
  },
  previewBookOrderCancelResult: function(data) {
    return request({
      url: '/api/v1/previewBookOrderCancelResult',
      method: 'post',
      data: Object.assign({
        thirdId: localStorage.getItem('openId')
      }, data)
    })
  },
  cancelBookOrder: function(data) {
    return request({
      url: '/api/v1/cancelBookOrder',
      method: 'post',
      data: Object.assign({
        thirdId: localStorage.getItem('openId')
      }, data)
    })
  },
  getBookableParksByLocation: function() {
    return request({
      url: '/api/v1/getBookableParksByLocation',
      method: 'post',
      data: {
        thirdId: localStorage.getItem('openId'),
        longitude: localStorage.getItem('lng'),
        latitude: localStorage.getItem('lat')
      }
    })
  }

}

export default api
